<template>
  <!-- Usage  -->
  <!-- <BottomDrawer
      :height="95"
      title="Supply products"
      :closeDrawer="closeDrawer"
      :isDrawerOpen="isDrawerOpen"
    >
      <template #header-button>
        <button>kdj</button>
      </template>

      <template #content> </template>
    </BottomDrawer> -->
  <!--  -->
  <section>
    <a-drawer
      :closable="false"
      placement="bottom"
      :open="isDrawerOpen"
      @close="closeDrawer"
      :height="`${height}%`"
      :style="{
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }"
    >
      <CustomToast />
      <header class="flex items-center justify-between pb-3 border-b">
        <section class="flex items-center gap-x-3">
          <div
            @click="closeDrawer"
            class="w-8 h-8 rounded-full cursor-pointer bg-gray-50 center-content"
          >
            <i class="text-xs font-bold text-black pi pi-times"></i>
          </div>

          <h3 class="text-xl font-medium">{{ title }}</h3>
        </section>

        <section class="min-w-[10%]">
          <slot name="header-button"></slot>
        </section>
      </header>

      <section class="">
        <slot name="content"></slot>
      </section>
    </a-drawer>
  </section>
</template>

<script>
import CustomToast from "../Toast/customToast.vue";

export default {
  name: "BottomDrawer",
  components: {
    CustomToast,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: false,
    },
    closeDrawer: {
      type: Function,
      required: true,
    },
    height: {
      required: false,
      type: [String, Number],
      default: 94,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

